import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { LoadingService } from '@shared/services/loading.service';
import { catchError, Observable, tap } from 'rxjs';
import { __param } from 'tslib';
import { SearchResultUiService } from '../../pages/search-result/services/search-result-ui.service';
import { ActivatedRoute } from '@angular/router';
import { SERVER_COOKIES } from '../../app.module';
import { UtmService } from '@core/services/utm.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
 currentHotel = signal('');
 loadingInit = signal(false);
 // searchResultService = inject(SearchResultUiService)

 PagesEndpoint = [
  {
   endpoint: 'home/GetAllSections',
   loadingText: 'در حال انتقال شما به صفحه اصلی ایران هتل',
  },
  {
   endpoint: 'getHotelSummaryInfo',
   loadingText: 'در حال انتقال شما به صفحه اطلاعات ',
  },
  {
   endpoint: 'search/filter',
   loadingText: 'در حال جستجوى بهترين واحد اقامتی براى شما',
  },
  {
   endpoint: 'search/accomodation',
   loadingText: 'در حال جستجوى بهترين واحد اقامتی براى شما',
  },
 ];

 constructor(
  private loadingService: LoadingService,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {}

 route = inject(ActivatedRoute);
 utmService = inject(UtmService);

 intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  if (request.url.includes(this.PagesEndpoint[2].endpoint)) this.loadingInit.set(true);
  if (
   request &&
   request.method == 'GET' &&
   this.loadingInit() &&
   !this.loadingService.loadingState()
  ) {
   switch (true) {
    case request.url.includes(this.PagesEndpoint[2].endpoint || this.PagesEndpoint[3].endpoint):
     let isFirstRequest = request.urlWithParams
      .split('&')
      .find((eachParam) => eachParam.split('=')[1] == 'true')
      ? true
      : false;


     if (
      isFirstRequest &&
      isPlatformBrowser(this.platformId)
     )
      this.loadingService.showNavigation(this.PagesEndpoint[2].loadingText);

     break;
    default:
     break;
   }
  }



  return next.handle(request).pipe(
   tap((response: any) => {
    if (response && response.url) {
     if (

      (response.url as string).includes(
       this.PagesEndpoint[2].endpoint || this.PagesEndpoint[3].endpoint
      ) &&
      response.status == 200
     ) {
      // window.scrollTo({ top: 0, behavior: 'instant' });
       if (isPlatformBrowser(this.platformId)) {
         this.loadingInit.set(true);
         this.loadingService.hideNavigation();
       } else if (isPlatformServer(this.platformId)) {
         this.loadingInit.set(true);
       }

      if (this.utmService.utmQueryString) 
       this.utmService.checkRouteParams(this.route.snapshot.queryParamMap);
     } else return response;
    }
   }),
   catchError((err) => {
    // this.loadingInit.set(false);
    // this.loadingService.hideNavigation();
     throw err;
   })
  );
 }
}
